import { Logout, Person, Settings } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Fade,
  Hidden,
  Menu,
  MenuItem,

} from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import user1 from "../../../Assets/Images/user1.jpg";
import Gene20Typography from "../../../Components/Gene20Typography";
const UserMenu = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  borderRadius: 24,
  padding: 4,
  "& span": { margin: "0 8px" },
}));
const StyledItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  minWidth: 185,
  "& a": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  },
  "& span": { marginRight: "10px", color: theme.palette.text.primary },
}));
export default function ProfileMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  let { shouldCloseOnItemClick = true, horizontalPosition = "left" } = props;
  return (
    <div>
      <UserMenu
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Hidden xsDown>
          <Gene20Typography variant="body2">
            Hi
            <strong>
              &nbsp;wilfred
              {/* {user.name} */}
            </strong>
          </Gene20Typography>
        </Hidden>
        <Avatar src={user1} sx={{ cursor: "pointer" }} />
      </UserMenu>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: horizontalPosition,
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: horizontalPosition,
        }}
      >
        <StyledItem onClick={handleClose}>
          <Person />
          <Gene20Typography variant="body2" color="light"> Profile</Gene20Typography>
        </StyledItem>
        <StyledItem onClick={handleClose}>
          <Settings />
          <Gene20Typography variant="body2" color="light">My account</Gene20Typography>
        </StyledItem>
        <StyledItem onClick={handleClose}>
          <Logout />
          <Gene20Typography variant="body2" color="light">Logout</Gene20Typography>
        </StyledItem>
      </Menu>
    </div>
  );
}
